import React from 'react';
import { IconOverviewType } from '../../../context/TransitsContextProvider';
import TrainOverview, { DirectionType } from '../../atoms/svg/TrainOverview';

const directions: { [key in number]: DirectionType } = {
  1: 'top',
  2: 'bottom',
  3: 'left',
  4: 'right'
};
Object.freeze(directions);

type Props = {
  icons: Array<IconOverviewType>;
  dispNo: boolean;
};

const TrainsOverview: React.FC<Props> = (props) => {
  const { icons, dispNo } = props;

  return (
    <>
      {icons.map((icon) => {
        return (
          <TrainOverview
            key={`train_overview_${icon.train_no}`}
            x={icon.x}
            y={icon.y}
            direction={directions[icon.arrow]}
            no={icon.train_no}
            color={icon.color}
            logo={icon.logo}
            dispNo={dispNo}
            opacity={icon.onStation ? 0.75 : 1}
          ></TrainOverview>
        );
      })}
    </>
  );
};

export default React.memo(TrainsOverview);
